var _g, _path, _ellipse, _ellipse2, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 194,
    height: 194,
    viewBox: "0 0 194 194",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_0_491)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7696 43.987C17.6158 29.1794 29.1794 17.6158 43.987 13.7696C78.7522 4.73969 115.248 4.73969 150.013 13.7696C164.821 17.6158 176.384 29.1794 180.23 43.987C189.26 78.7522 189.26 115.248 180.23 150.013C176.384 164.821 164.821 176.384 150.013 180.23C115.248 189.26 78.7522 189.26 43.987 180.23C29.1794 176.384 17.6158 164.821 13.7696 150.013C4.73969 115.248 4.73969 78.7522 13.7696 43.987Z",
    fill: "url(#paint0_linear_0_491)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.093 45.3697C22.4375 32.4931 32.4931 22.4375 45.3697 19.093C79.2281 10.2986 114.772 10.2986 148.63 19.093C161.507 22.4375 171.562 32.4931 174.907 45.3697C183.701 79.2281 183.701 114.772 174.907 148.63C171.562 161.507 161.507 171.562 148.63 174.907C114.772 183.701 79.2281 183.701 45.3697 174.907C32.4931 171.562 22.4375 161.507 19.093 148.63C10.2986 114.772 10.2986 79.2281 19.093 45.3697Z",
    stroke: "white",
    strokeWidth: 11,
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 145.648,
    cy: 42.8191,
    rx: 19.4601,
    ry: 7.77356,
    transform: "rotate(31.6062 145.648 42.8191)",
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.553,
    cy: 142.714,
    rx: 8.65002,
    ry: 4.65757,
    transform: "rotate(14.8094 48.553 142.714)",
    fill: "white",
    fillOpacity: 0.9
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_0_491)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.8145 84.9833L138.958 78.4722C142.575 77.9505 145.814 80.7562 145.814 84.4107V96.6866C145.814 100.296 142.651 103.088 139.07 102.64L93.8145 96.9833V84.9833Z",
    fill: "url(#paint1_linear_0_491)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.2208 104.008C94.4359 114.27 83.4613 120.917 74.4663 115.972L50.1801 102.621C41.1852 97.6763 40.9162 84.8485 49.696 79.5311L73.4013 65.174C82.1811 59.8566 93.4247 66.0375 93.6399 76.2998L94.2208 104.008Z",
    fill: "url(#paint2_linear_0_491)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_0_491",
    x: 6.99707,
    y: -15.4028,
    width: 203.006,
    height: 217.406,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 23,
    dy: 15
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.388235 0 0 0 0 0.717647 0 0 0 0 0.00392157 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_0_491"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 27,
    dy: -25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.373361 0 0 0 0 0.531235 0 0 0 0 0.0175931 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_0_491",
    result: "effect2_innerShadow_0_491"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_0_491",
    x: 26.4695,
    y: 50.426,
    width: 136.145,
    height: 88.0154,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_491"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_491",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_491",
    x1: 97,
    y1: 0,
    x2: 97,
    y2: 194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71BE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56B000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_491",
    x1: 120,
    y1: 137.5,
    x2: 118.814,
    y2: 80.9833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BBB01",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_0_491",
    x1: 73,
    y1: 197,
    x2: 84.9534,
    y2: 69.6027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#CCFC91",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackButton);
export default __webpack_public_path__ + "static/media/back-button.07f16769afcfd9522cd2ed064e1b9ab9.svg";
export { ForwardRef as ReactComponent };